__webpack_require__.p = "/binfe_portfolio/";